import SubscriptionServices from "@/services/subscriptionServices";
import { useQuery } from "@tanstack/react-query";

/**
 * Hook to fetch brand logo from Brandfetch API
 * @param brandName - The name of the brand to fetch the logo for
 * @param enabled - Whether to enable the query (default: true)
 * @returns Object containing the icon URL and loading state
 */
export function useBrandLogo(brandName: string, enabled: boolean = true) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["brandIcon", brandName],
    queryFn: () => SubscriptionServices.fetchBrandIcon(brandName),
    enabled: enabled && !!brandName,
    staleTime: 1000 * 60 * 60 * 24, // Cache for 24 hours
    gcTime: 1000 * 60 * 60 * 24 * 7, // Keep in cache for 7 days
  });

  const icon = data?.data?.[0]?.icon ?? null;

  return {
    icon,
    isLoading,
    error,
  };
}

export default useBrandLogo;
